
import React from "react";
import "./LandingNutrition.css";

const COPY = {
  ru: {
    section: "01 / ПИТАНИЕ",
    title: ["СФОТОГРАФИРУЙ", "ЕДУ — ОСТАЛЬНОЕ", "ПОСЧИТАЕТ ИИ"],
    desc: ["КБЖУ по фото —", "в дневник питания."],
    kcalAmount: "≈ 540", unit: "ккал", protein: "Белки", fat: "Жиры", carbs: "Углеводы",
  },
  en: {
    section: "01 / NUTRITION",
    title: ["PHOTO YOUR", "FOOD — AI HANDLES", "THE REST"],
    desc: ["Photo-based calories", "and macros — into your", "nutrition diary."],
    kcalAmount: "≈ 540", unit: "kcal", protein: "Protein", fat: "Fat", carbs: "Carbs",
  },
};

export default function LandingNutrition({ language = "ru", imageSrc = "/landing/food-bowl.webp" }) {
  const isEnglish = String(language).toLowerCase().startsWith("en");
  const text = isEnglish ? COPY.en : COPY.ru;

  return (
    <section className={`lnutri ${isEnglish ? "lnutri-en" : ""}`} id="landing-nutrition" aria-label={isEnglish ? "Nutrition" : "Питание"}>
      <div className="lnutri-inner">
        <div className="lnutri-card">
          <div className="lnutri-copy">
            <div className="lnutri-section">{text.section}</div>
            <h2 className="lnutri-title">
              {text.title.map((line) => <span key={line}>{line}</span>)}
            </h2>
            <p className="lnutri-desc">
              {text.desc.map((line) => <span key={line}>{line}</span>)}
            </p>
          </div>
          <div className="lnutri-visual" aria-hidden="true">
            <span className="lnutri-scan lnutri-scan-tl" />
            <span className="lnutri-scan lnutri-scan-tr" />
            <span className="lnutri-scan lnutri-scan-bl" />
            <span className="lnutri-scan lnutri-scan-br" />
            <img src={imageSrc} alt="" className="lnutri-bowl" loading="lazy" />
          </div>
          <div className="lnutri-kcal">
            <div className="lnutri-kcal-main"><strong>{text.kcalAmount}</strong> <span>{text.unit}</span></div>
            <div className="lnutri-macros">
              <span><i className="lnutri-dot lnutri-dot-protein" />{text.protein}</span>
              <span><i className="lnutri-dot lnutri-dot-fat" />{text.fat}</span>
              <span><i className="lnutri-dot lnutri-dot-carbs" />{text.carbs}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
